import {home} from './parts/home.js';
import {subpage} from './parts/subpage.js';
import {forms} from './parts/forms.js';
import {contactForm} from './parts/contact.js';
import {groozForm} from './parts/grooz.js';
import {setGoogleMap} from './parts/googleMap.js';
import {loadMorePosts} from './parts/blog.js';
import {register} from './parts/register.js';
import {panel} from './parts/panel.js';
import {opinion} from './parts/opinion.js';
import {search} from './parts/search.js';

(function ($) {

    //-- delay function for resizing
    var delay = (function() {
        var timer = 0;
        return function(callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        }
    })();

    if (typeof Dropzone !== 'undefined') {
        Dropzone.autoDiscover = false;
    }

    $(document).ready(function(){

        $('select').niceSelect();

        //-- magnific
        $('.popup-img').magnificPopup({
            type: 'image',
            mainClass: 'mfp-with-zoom', // this class is for CSS animation below
            zoom: {
                enabled: true, // By default it's false, so don't forget to enable it
                duration: 300, // duration of the effect, in milliseconds
                easing: 'ease-in-out', // CSS transition easing function
            }
        });

        // TOP MENU
        $('.hamburger-top').click(function(e){
            e.preventDefault();

            if ($('.navigation').hasClass('open')) {
                $('.menu-mobile').fadeOut();
                $('.navigation').removeClass('open');
                $('.navigation').removeClass('fixed');
            } else {
                $('.menu-mobile').fadeIn();
                $('.navigation').addClass('open');
                $('.navigation').addClass('fixed');
            }
        });

        // Close menu
        $('.menu-mobile').click(function(e){
            if ($('.navigation').hasClass('open')) {
                $('.menu-mobile').fadeOut();
                $('.navigation').removeClass('open');
                $('.navigation').removeClass('fixed');
            }

            if ($('.navigation-mobile').hasClass('open')) {
                $('.menu-mobile').fadeOut();
                $('.navigation-mobile').removeClass('open');
            }
        });

        // MOBILE MENU
        $('.hamburger').click(function(e){
            e.preventDefault();

            if ($('.navigation-mobile').hasClass('open')) {
                $('.menu-mobile').fadeOut();
                $('.navigation-mobile').removeClass('open');
            } else {
                $('.menu-mobile').fadeIn();
                $('.navigation-mobile').addClass('open');
            }
        });

        // VALIDATION
        $("input.only-numbers").keypress(function (e) {
            if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
                return false;
            }
        });

        if ($('.page-content').hasClass('home')){
            home();
        }

        if ($('.page-content').hasClass('subpage') && !$('.page-content').hasClass('order-form')){
            subpage();
        }

        if ($('.page-content').hasClass('register')){
            register();
        }

        if ($('.page-content').hasClass('panel')){
            panel();
        }

        if ($('.page-content').hasClass('grooz-page')){
            groozForm();
        }

        forms();
        contactForm();
        loadMorePosts();

        // default validation messages
        $.validator.messages.required = "Wymagane";
        $.validator.messages.email = "Zły format e-mail";

        opinion();
        search();

    });

    $(window).on({
        load:function(){
            setTimeout(function(){
                $('.cta-box').toggleClass("show");
                $('.cabine-box').toggleClass("show");
            }, 500);

            if ($('#map').length === 1) {
                setGoogleMap();
            }

            // scrool to search results on mobile devices
            if ($('.results-info h1').length > 0 && $(window).width() <= 991) {
                var offset = $('.results-info h1').offset().top-10;

                $('html, body').animate({
                    scrollTop: offset
                }, 500);
            }
        },
        resize:function(){


        },
        scroll:function(){

       }
    });

}(jQuery));